import React, { createContext, useContext, useEffect, useReducer } from "react";
import apiCall from "../components/Api/api";
import { masterReducer } from "../reducers/masterReducer";

//Create context
export const MasterContext = createContext();

//Initial state
const initialState = {
  parks: [],
  parksWithSlug: [],
  months: [],
  packageFeature: [],
  packageInclude: [],
  animals: [],
  animalsDefault: [],
  locations: [],
  vehicles: [],
  bonusExperience: [],
  suggestionCategory: [],

  safariType: [],
  safariAgenda: [],
  safariCategory: [],
  safariHostType: [],
  safariSortBy: [],
  safariPackSortBy: [],
  parksSortBy: [],
  flagReasons: [],
  masterLoading: true,

};

//Provider
const MasterProvider = ({ children }) => {
  const [masterState, masterDispatch] = useReducer(masterReducer, initialState);

  useEffect(() => {
    const fetchMasters = async () => {
      try {
        masterDispatch({ type: "SET_MASTER_LOADING", payload: true });
        // Or example of parallel requests using Promise.all
        const [
          parkRes,
          monthRes,
          packFeatureRes,
          packIncludeRes,
          animalsRes,
          locationRes,
          vehicleRes,
          bonusExpRes,
          suggCatRes,
          flagReasonsRes
        ] = await Promise.allSettled([
          apiCall({ url: `filter-parklist`, method: "GET" }),
          apiCall({ url: `master/month?pageSize=20`, method: "GET" }),
          apiCall({ url: `master/package-feature?pageSize=20`, method: "GET" }),
          apiCall({ url: `master/package-include?pageSize=20`, method: "GET" }),
          apiCall({ url: `master/animal?is_filter=1&animal_type=1&pageSize=10`, method: "GET" }),
          apiCall({ url: `master/location?pageSize=50`, method: "GET" }),
          apiCall({ url: `master/vehicle?pageSize=50`, method: "GET" }),
          apiCall({ url: `master/bonus-experience?pageSize=50`, method: "GET" }),
          apiCall({ url: `master/suggestion-category?pageSize=50`, method: "GET" }),
          apiCall({ url: `sharesafari/flagreason`, method: "GET" }),

        ]);

        if (parkRes.status === "fulfilled" && parkRes.value.status === 200) {
          const data = parkRes.value.data?.parks?.data;

          // Sort parks alphabetically by title (case-insensitive)
          const sortedData = [...data].sort((a, b) =>
            a.title.localeCompare(b.title, undefined, { sensitivity: 'base' })
          );

          const options = sortedData.map((park) => ({
            label: park.title,
            value: park.id,
          }));


          const optionsWithSlug = [
            { label: "All / Any", value: 0 },
            ...sortedData.map((park) => ({
              label: park.title,
              value: park.id,
              slug: park?.slug
            })),
          ];

          masterDispatch({ type: "SET_MASTER_PARKS", payload: options });
          masterDispatch({ type: "SET_MASTER_PARKS_WITH_SLUG", payload: optionsWithSlug });

        } else {
          console.error("Parks API failed:", parkRes.reason);
        }
        if (monthRes.status === "fulfilled" && monthRes.value.status === 200) {
          const data = monthRes.value.data?.master_month?.data;
          const options = data.map((park) => ({
            label: park.month_name,
            value: park.month,
          }));
          masterDispatch({ type: "SET_MASTER_MONTHS", payload: options });
        } else {
          console.error("Months API failed:", monthRes.reason);
        }
        if (packFeatureRes.status === "fulfilled" && packFeatureRes.value.status === 200) {
          const data = packFeatureRes.value.data?.master_package_feature?.data;
          const options = data.map((feature) => ({
            label: feature.title,
            value: feature.id,
          }));
          masterDispatch({ type: "SET_MASTER_PACKAGE_FEATURE", payload: options });
        } else {
          console.error("Package Feature API failed:", packFeatureRes.reason);
        }
        if (packIncludeRes.status === "fulfilled" && packIncludeRes.value.status === 200) {
          const data = packIncludeRes.value.data?.master_package_include?.data;
          const options = data.map((feature) => ({
            label: feature.title,
            value: feature.id,
          }));
          masterDispatch({ type: "SET_MASTER_PACKAGE_INCLUDE", payload: options });
        } else {
          console.error("Package Include API failed:", packIncludeRes.reason);
        }
        if (animalsRes.status === "fulfilled" && animalsRes.value.status === 200) {
          const data = animalsRes.value.data?.master_animal?.data;
          const options = [
            { label: "All / Any", value: 0 },
            ...data.map((animal) => ({
              label: animal.name,
              value: animal.id,
            })),
          ];
          masterDispatch({ type: "SET_MASTER_ANIMALS", payload: options });
          masterDispatch({ type: "SET_MASTER_ANIMALS_DEFAULT", payload: options });
        } else {
          console.error("Animal API failed:", animalsRes.reason);
        }
        if (locationRes.status === "fulfilled" && locationRes.value.status === 200) {
          const data = locationRes.value.data?.master_location?.data;
          const options = [
            { label: "All / Any", value: 0 },
            ...data.map((location) => ({
              label: location.title,
              value: location.id,
            })),
          ];
          masterDispatch({ type: "SET_MASTER_LOCATIONS", payload: options });
        } else {
          console.error("Locations API failed:", locationRes.reason);
        }
        if (vehicleRes.status === "fulfilled" && vehicleRes.value.status === 200) {
          const data = vehicleRes.value.data?.master_vehicle?.data;
          const options = [
            { label: "All / Any", value: 0 },
            ...data.map((vehicle) => ({
              label: vehicle.vehicle_name,
              value: vehicle.id,
            })),
          ];
          masterDispatch({ type: "SET_MASTER_VEHICLES", payload: options });
        } else {
          console.error("Vehicles API failed:", vehicleRes.reason);
        }
        if (bonusExpRes.status === "fulfilled" && bonusExpRes.value.status === 200) {
          const data = bonusExpRes.value.data?.master_bonus_experience?.data;
          // const options = [
          //   { label: "All / Any", value: 0 },
          //   ...data.map((bonus) => ({
          //     label: bonus.title,
          //     value: bonus.id,
          //   })),
          // ];
          const options = [
            ...data.map((bonus) => ({
              label: bonus.title,
              value: bonus.id,
            })),
          ];
          masterDispatch({ type: "SET_MASTER_BONUS_EXPERIENCE", payload: options });
        } else {
          console.error("Bonus Exprience API failed:", bonusExpRes.reason);
        }
        if (suggCatRes.status === "fulfilled" && suggCatRes.value.status === 200) {
          const data = suggCatRes.value.data?.master_suggestion_category?.data;
          // const options = [
          //   { label: "All / Any", value: 0 },
          //   ...data.map((bonus) => ({
          //     label: bonus.title,
          //     value: bonus.id,
          //   })),
          // ];
          const options = data.map((bonus) => ({
            label: bonus.title,
            value: bonus.id,
          }))

          masterDispatch({ type: "SET_MASTER_SUGGESTION_CATEGORY", payload: options });
        } else {
          console.error("Bonus Exprience API failed:", suggCatRes.reason);
        }
        if (flagReasonsRes.status === "fulfilled" && flagReasonsRes.value.status === 200) {
          const data = flagReasonsRes.value.data;
          const options = data.map((item) => ({
            label: item.reason,
            value: item.id,
          }));

          masterDispatch({ type: "SET_MASTER_FLAG_REASONS", payload: options });
        } else {
          console.error("Flag Reasons API failed:", flagReasonsRes.reason);
        }
        const safariType = [{ label: "Shared Safari", value: 1 }, { label: "Fixed Departure", value: 2 }];
        const safariAgenda = [{ label: "Photography", value: 1 }, { label: "Safari Experience", value: 3 }];
        const safariCategory = [{ label: "Premium", value: 1 }, { label: "Standard", value: 2 }, { label: "Economical", value: 3 }, { label: "Not Included", value: 4 }, { label: "Forest Rest House", value: 5 }, { label: "Home Stay", value: 6 }];
        const safariHostType = [{ label: "Individual", value: 1 },
        // { label: "Wildlife", value: 2 }, 
        { label: "Safari Operator", value: 3 }];
        const safariSortBy = [
          { value: "0", label: "Sort by" },
          { value: "1", label: "Created Recently" },
          { value: "2", label: "Less Safaris" },
          { value: "3", label: "More Safaris" },
          { value: "4", label: "Cheapest" },
          { value: "5", label: "Occurrence: Newest First" },
          { value: "6", label: "Occurrence: Oldest First" },];

        const packageSortBy = [
          { value: "0", label: "Sort By" }, 
          { value: "5", label: "Popular" }, 
          { value: "1", label: "Created Recently" }, 
          { value: "2", label: "Less Safaris" }, 
          { value: "3", label: "More Safaris" }, 
          { value: "4", label: "Cheapest" }];
        const parkSortBy = [{ label: "Sort by : Most Demanding", value: 1 }, { label: "A to Z", value: 2 }, { label: "Z to A", value: 3 }];
        masterDispatch({ type: "SET_MASTER_SAFARI_TYPE", payload: safariType });
        masterDispatch({ type: "SET_MASTER_SAFARI_THEME", payload: safariAgenda });
        masterDispatch({ type: "SET_MASTER_SAFARI_CATEGORY", payload: safariCategory });
        masterDispatch({ type: "SET_MASTER_SAFARI_HOST_TYPE", payload: safariHostType });
        masterDispatch({ type: "SET_MASTER_SAFARI_SORT_BY", payload: safariSortBy });
        masterDispatch({ type: "SET_MASTER_SAFARI_PACKAGES_SORT_BY", payload: packageSortBy });
        masterDispatch({ type: "SET_MASTER_PARKS_SORT_BY", payload: parkSortBy });

      } catch (error) {

        console.error(error)
        masterDispatch({ type: "SET_MASTER_LOADING", payload: false });
      } finally {
        masterDispatch({ type: "SET_MASTER_LOADING", payload: false });
      }
    };

    // fetch all master
    fetchMasters();
  }, []);
  return (
    <MasterContext.Provider
      value={{
        ...masterState,
        masterDispatch,
      }}
    >
      {children}
    </MasterContext.Provider>
  );
};

//hook
export const useMasterContext = () => useContext(MasterContext);

export default MasterProvider;
